import React, { useState } from "react";
import ReactPlayer from "react-player";
import { InnerHOC } from "../../Layout/LoggedInLayout/innerPage";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";

import { useAtom } from "jotai";
import { appConstants } from "../../AtomStore/store";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";

const ParentOrientationVideos = () => {
  const [constants] = useAtom(appConstants);
  const ParentOrientationVideos = constants?.ParentOrientationVideos;

  // Track loading state for each video
  const [loadingStates, setLoadingStates] = useState(
    Array(ParentOrientationVideos?.length || 0).fill(true)
  );

  const handleReady = (index) => {
    setLoadingStates((prev) => {
      const updated = [...prev];
      updated[index] = false;
      return updated;
    });
  };

  return (
    // <InnerHOC heading="Videos">
    <>
      {Array.isArray(ParentOrientationVideos) &&
      ParentOrientationVideos.length > 0 ? (
        <div className="px-2">
          <div className="pt-3 text-sm text-left">
            <h2 className="text-left text-base mb-1 text-black font-semibold">
              Welcome to Our Parent Orientation Program
            </h2>
            Thank you for joining us. This video will guide you through our
            playschool's vision, daily activities, facilities, and the nurturing
            environment we proudly offer to your child.
          </div>
          <div className="space-y-4 mt-4">
            {ParentOrientationVideos.map((url, index) => (
              <div key={index} className="relative">
                {loadingStates[index] && <SpinnerLoading />}
                <ReactPlayer
                  url={url}
                  width="100%"
                  controls={true}
                  onReady={() => handleReady(index)}
                  onBuffer={() => handleReady(index)} // Optional: shows after buffering
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <ListEmptyComponent />
      )}
    </>
    // </InnerHOC>
  );
};

export default ParentOrientationVideos;
